import styled from "styled-components";
import {flexGrowItem} from "../../../../themes/architecture/css-helpers/flex";
import {hexToRgba} from "../../../../themes/hex-to-rgba";

export const FilterCategoriesListBox = styled.div`
    ${flexGrowItem};
    flex-basis: 1%;  /* We need it so this area will not take all the places(including the sticky buttons) */
    overflow-y: auto;
    background-color: ${({theme}) => hexToRgba(theme.colors.backgroundMiddleDark, 0.25)};
    padding-inline: 15px;
`;